// extracted by mini-css-extract-plugin
export default {"landingPage":"Campaign3_landingPage__PtCZ1","landingImg":"Campaign3_landingImg__Ci4Hv","tcButton":"Campaign3_tcButton__6Ki3z"};